import React, { useEffect } from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { BottomNav } from '../../components/app/BottomNav';
import { isAuthed } from './appApi';

/**
 * Layout for /app/* routes.
 * - Gates access: redirects to /app/login if not authenticated
 * - Renders child route via <Outlet/>
 * - Fixed bottom tab bar
 * - Hides the global Emergent badge (would overlap the bottom nav on mobile)
 */
export const AppShell = () => {
  const location = useLocation();

  useEffect(() => {
    document.body.classList.add('pwa-mode');
    // Also directly hide the Emergent badge (CSS alone sometimes races).
    const badge = document.getElementById('emergent-badge');
    if (badge) badge.style.display = 'none';
    return () => {
      document.body.classList.remove('pwa-mode');
      if (badge) badge.style.display = '';
    };
  }, []);

  if (!isAuthed()) {
    return <Navigate to="/app/login" state={{ from: location.pathname }} replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <main
        className="flex-1 pb-20"
        style={{ paddingBottom: 'calc(env(safe-area-inset-bottom) + 64px)' }}
      >
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
};
